<template>
  <div>
    <a-card size="small" title="导航分类">
      <a slot="extra" v-has="{ code: 'system:navigation:category:add', project: 0 }" @click="onAdd"> <a-icon type="plus" /> 添加分类 </a>
      <div v-for="(category, index) in categoryList" :key="index">
        <div :class="`${category.id === currentCategory ? 'category-item category-item_active' : 'category-item'}`" @click="onCategroy(category.id)">
          <span class="category-item_name">{{ category.name }}</span>
          <span v-if="category.id !== null" class="category-item_more">
            <a v-has="{ code: 'system:navigation:category:edit', project: 0 }" style="margin: 0 4px" @click="onEdit(category)"><a-icon type="edit" /> </a>
            <a v-has="{ code: 'system:navigation:category:delete', project: 0 }" style="margin: 0 4px" @click="onDelete(category.id)"><a-icon type="delete" /> </a>
          </span>
        </div>
      </div>
    </a-card>
    <categroy-modal :is-show="visible" :category-id="categoryId" :category-data="categoryData" @close="close" />
  </div>
</template>

<script>
import { navigationCategoryList, navigationCategoryDelete } from '@/api/system/navigation';
import CategroyModal from '@/pages/system/navigation/CategroyModal';

export default {
  components: { CategroyModal },
  data() {
    return {
      loading: false,
      categoryTotal: 0,
      categoryList: [],
      currentCategory: null,
      categoryId: null,
      categoryData: {},
      visible: false
    };
  },
  watch: {
    currentCategory() {
      this.$emit('selected', this.currentCategory);
    }
  },
  created() {
    this.getCategroyList();
  },
  methods: {
    getCategroyList() {
      this.loading = true;
      navigationCategoryList({})
        .then(res => {
          this.categoryList = [{ id: null, name: '全部' }, ...res.data.items];
          this.total = res.data.total;
          if (this.currentCategory === null) {
            this.currentCategory = this.categoryList[0].id;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onDelete(categroy_id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这个分类吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          navigationCategoryDelete({ id: categroy_id }).then(() => {
            self.$message.success('删除成功');
            self.getCategroyList();
          });
        }
      });
    },

    onCategroy(categroy_id) {
      this.currentCategory = categroy_id;
    },

    onAdd() {
      this.visible = true;
    },

    onEdit(categroy) {
      this.categoryId = categroy.id;
      this.categoryData = {
        name: categroy.name,
        sort: categroy.sort
      };
      this.visible = true;
    },

    close(type = 'cancel') {
      this.visible = false;
      this.categoryId = null;
      this.categoryData = {};
      if (type !== 'cancel') {
        this.getCategroyList();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
  padding: 12px 0;
  height: calc(~'100vh - 180px');
}

.category-item {
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  padding: 0 16px;
}

.category-item:hover,
.category-item_active {
  background-color: #e6f7ff;
  color: #1890ff;
}

.category-item_more {
  float: right;
  font-weight: bold;
}
</style>
